import {Component, Prop, Vue} from "vue-property-decorator";
import Icon from "@/components/icon";
import Progress from "./progress";
import {UploadService} from "@/lib/services/services-signatures";
import UploaderPreview from "@/components/uploader/preview";
import CavAbstractDocument from "@/lib/models/cav-abstract-document";

// protected function onStateDocument(evt:WrapperEvent):void {
//   fileFilter = null;
// }
//
// protected function onStatePhoto(evt:WrapperEvent):void {
//   fileFilter = new FileFilter("Images", "*.jpg;*.gif;*.png;*.jpeg");
// }
//
// protected function onStateScan(evt:WrapperEvent):void {
//   fileFilter = new FileFilter("Images", "*.jpg;*.gif;*.png;*.jpeg");
// }

@Component
class Uploader extends Vue {

  @Prop({default: "Téléverser un document", type: String}) readonly buttonLabel!: string;
  @Prop({default: true, type: Boolean}) readonly preview!: boolean;
  @Prop({default: true, type: Boolean}) readonly withProgress!: boolean;
  @Prop({default:null, type: Object }) readonly value!: CavAbstractDocument;
  @Prop({required:true, type: Function}) readonly service!: UploadService;

  private isUploading: boolean = false;
  private progress: number = 0;
  private total: number = 0;

  private prepareFileUpload(file) : FormData {
    const data = new FormData();
    data.append("file", file);
    return data;
  }

  async handleFileSelection(e){

    const { files: [file] } = e.target;
    // TODO: mime and size filters

    try {
      this.isUploading = true;
      this.$emit("uploadStart");
      const fileData = await this.service({
        data: this.prepareFileUpload(file),
        onUploadProgress: progressEvt => {
          this.total = progressEvt.total;
          this.progress = progressEvt.loaded;
          this.$emit("uploadProgress", {value: this.progress, total: this.total});
        }
      });
      this.$emit("uploadEnd", fileData);
    } catch(error){
      this.$emit("uploadError", error);
    }
    this.isUploading = false;
  }

  renderUploadIcon() {
    return this.preview ? (
      <figure class="uploader-icon">
        <Icon icon="upload"/>
      </figure>
    ) : null;
  }

  shouldShowPreview(){
    return this.preview && this.value.hasFile()
  }

  renderIdleState(){
    return [
      this.shouldShowPreview() ? <UploaderPreview value={this.value} /> : this.renderUploadIcon(),
      <div class="uploader-btn file">
        <label class="file-label">
          {this.$slots.default || (
            <span class="file-cta">
              <span class="file-label">{this.buttonLabel}</span>
            </span>
          )}
          <input class="file-input" type="file" name="resume" onChange={this.handleFileSelection} />
        </label>
      </div>
    ];
  }

  renderProgressState(){
    return <Progress progress={this.progress} total={this.total} />;
  }

  render() {
    return (
      <div class="uploader">
        <div class="uploader-container has-text-centered">
          { this.isUploading && this.withProgress ? this.renderProgressState() : this.renderIdleState() }
        </div>
      </div>
    );
  }
}

export default Uploader;

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-352c1c52/uploader.tsx" });